import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import { ActionCheckbox } from '~/components/Patient/Gap/Actions';
import { enums, getFocActionName } from '~/util';

const propTypes = {
    action: PropTypes.shape().isRequired,
    checkboxId: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    formik: PropTypes.shape().isRequired,
};

export function FocActionCheckRow({ action, checkboxId, readOnly, formik }) {
    return (
        <>
            <tr
                className={`foc-gap-action-row gap-action-row ${
                    formik.errors[checkboxId] && formik.touched[checkboxId] ? 'text-danger' : ''
                }`}
            >
                <td className="checkbox-col" aria-label="Checkbox">
                    <div className="text-center">
                        <ActionCheckbox checkBoxId={checkboxId} readOnly={readOnly} />
                    </div>
                </td>
                <td className="col-gap-action-name">
                    <label htmlFor={checkboxId} className="mb-0">
                        {getFocActionName(action)}
                    </label>
                </td>
                <td className="w-20">{action.foc_action_details?.[0]?.acceptable_dates}</td>
                <td className="w-10">
                    {enums(['gap', 'frequency', action.foc_action_details?.[0]?.frequency])}
                </td>
            </tr>
            {formik.errors[checkboxId] && (
                <tr className="quality-gap-action-row">
                    <td colSpan={4} aria-label="Error">
                        <div className="text-danger">
                            <ErrorMessage name={checkboxId} />
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
}

FocActionCheckRow.propTypes = propTypes;
